module.exports = __webpack_public_path__ + "media/images/lb/788-a673ebf1efec150ba72da2410fa044be.svg";